import React from 'react'
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

export default function ToastNotification({ openToaster, message, toastType = 'success', handleClose = undefined,variant = "filled" ,alertTitle = "", style={} }) {
    return (
        <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={true}
            autoHideDuration={2000}
           >
            <Alert
                severity={toastType}
                variant={variant}
                sx={{ width: '100%', ...style }}
            >
                {alertTitle && <AlertTitle>{alertTitle}</AlertTitle>}
                {message}
            </Alert>
        </Snackbar>
    )
}
